"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.defaultProps = void 0;

var types_1 = require("./types");

exports.defaultProps = {
  activeIndex: 0,
  animationDuration: 400,
  animationEasingFunction: "ease",
  animationType: types_1.AnimationType.SLIDE,
  autoHeight: !1,
  autoWidth: !1,
  autoPlay: !1,
  autoPlayControls: !1,
  autoPlayDirection: types_1.AutoplayDirection.LTR,
  autoPlayInterval: 400,
  autoPlayStrategy: types_1.AutoPlayStrategy.DEFAULT,
  children: void 0,
  controlsStrategy: types_1.ControlsStrategy.DEFAULT,
  disableButtonsControls: !1,
  disableDotsControls: !1,
  disableSlideInfo: !0,
  infinite: !1,
  items: void 0,
  mouseTracking: !1,
  paddingLeft: 0,
  paddingRight: 0,
  responsive: void 0,
  swipeDelta: 20,
  swipeExtraPadding: 200,
  touchTracking: !0,
  touchMoveDefaultEvents: !0,
  onInitialized: function onInitialized() {},
  onResized: function onResized() {},
  onResizeEvent: void 0,
  onSlideChange: function onSlideChange() {},
  onSlideChanged: function onSlideChanged() {}
};